import Leaderboard, { IItemInfo } from 'Components/series/leaderboard'
import { ICommunity } from 'Pages/community/recommend-communities'
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import ScrollLoader from 'Components/scroll-loader'
import Loading from 'Components/loading'
import ArticleCard from 'Components/ugc/article-card'
import { stringify } from 'querystring'
import classNames from 'classnames'
import Button from 'Components/button'
import { CloseIconForPublisher } from 'Components/publisher/close-icon'
import Modal from 'Components/modal'
import Publisher, { IPB } from 'Components/publisher/publisher'
import { GlobalStoreContext } from 'Components/store'
import { mockNewCard } from 'lib/mock-new-card'
import { FeedContext } from 'Pages/car_fans_community/feed'
import Favour from 'Components/series/favour'
import CarList from 'Components/series/car-list'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetch from 'lib/decorated-fetch'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'

const publish_icon = require('static/publish@3x.png')
const empty_icon = require('static/empty-envelope.png')

interface IQA {
  rankData: IItemInfo[]
  seriesId: number
  seriesName: string
}

interface IQATab {
  chi_name: string
  tab_name: string
  dropdown_list: {
    tab_filter_show_name: string
    type: number
    name: string
    tab_filter_select_name: string
  }[]
  dropdown_enter_name: string
}

export default function QA(props: IQA) {
  const { rankData, seriesId, seriesName } = props
  const [motorId, setMotorId] = useState(0)
  const [qas, setQAs] = useState<any[]>([])
  const [refresh_num, setRefreshNum] = useState(0)
  const [lastMax, setLastMax] = useState(0)
  const [loading, setLoading] = useState(false)
  const [subMenu, setSubMenu] = useState<IQATab[]>([])
  const [activeSubTab, setActiveSubTab] = useState('all')
  const [showPublisher, setShowPublisher] = useState(false)
  const [useSkin2, setUseSkin2] = useState(false)
  const { state: globalState } = useContext(GlobalStoreContext)
  const ref = useRef<HTMLDivElement | null>(null)

  const fetchQAs = async (refresh_num: number) => {
    let newQAs = []
    try {
      const category =
        activeSubTab === 'all' ? 'series_wenda_publish' : activeSubTab
      const params: any = {
        motor_feed_extra_params: JSON.stringify({
          new_feed: true,
          feed_type: 0,
        }),
        category,
        motor_id: motorId,
        impression_info: JSON.stringify({
          page_id: 'page_common_question_ask',
          sub_tab: category,
          motor_id: motorId,
        }),
        cmg_flag: category,
        count: 20,
      }
      if (refresh_num === 0) {
        params.min_cursor = 0
      } else {
        params.max_cursor = lastMax
      }
      // cmg_flag 为 wenda 时 替换为 series_wenda_publish
      if (params?.cmg_flag === 'wenda') {
        params.cmg_flag = 'series_wenda_publish'
      }
      const json = await fetch(
        `/motor/discuss_ugc/cheyou_feed_list_v3/v1/?${stringify(params)}`
      ).catch((e) => {
        // no-op
      })
      newQAs = json?.data?.list || []
      setLastMax(newQAs[newQAs.length - 1]?.info?.cursor)
      setRefreshNum(refresh_num + 1)
    } catch (err) {
      // no-op
    }
    if (refresh_num > 0) {
      setQAs([...qas, ...newQAs])
    } else {
      setQAs([...newQAs])
    }
  }

  useEffect(() => {
    fetch(`/motor/discuss_ugc/wenda/get_head?series_id=${seriesId}`)
      .then((json) => {
        setSubMenu(json.data?.tab_info?.tab_list || [])
        setMotorId(json.data?.car_info?.motor_id || 0)
      })
      .catch((err) => {
        // no-op
      })
  }, [seriesId])

  useEffect(() => {
    if (motorId === 0) {
      return
    }
    setQAs([])
    setLoading(true)
    fetchQAs(0).finally(() => {
      setLoading(false)
    })
  }, [motorId, activeSubTab])

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0],
    }
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          setUseSkin2(true)
        }
      })
    }, options)
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [])
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '-1px',
      threshold: [1],
    }
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setUseSkin2(false)
        }
      })
    }, options)
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [])

  const loadMoreHandler = async () => {
    if (motorId === 0) {
      return
    }
    setLoading(true)
    await fetchQAs(refresh_num)
    setLoading(false)
  }
  const handleTogglePublisher = useLoginCheckCallback(
    useCallback(() => {
      sendTeaCommEvent('click_publish_btn', {
        car_series_id: seriesId,
      })
      setShowPublisher(!showPublisher)
    }, [showPublisher]),
    useMemo(() => {
      return {
        enter_method: 'publish',
      }
    }, [])
  )

  const handlePublish = async (props: IPB) => {
    const { isTimer } = props
    if (!isTimer) {
      const user_id = globalState?.userData?.user_id
      if (!user_id) {
        return
      }
      const newData = await mockNewCard({ ...props, user_id })
      setQAs([newData as any, ...qas])
    }
    setShowPublisher(false)
  }
  const handleDelete = useCallback(
    (gid: string) => {
      setQAs(qas.filter((ele) => ele.unique_id_str !== gid))
    },
    [qas]
  )

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="left-part">
          <div
            className={classNames('head', {
              'skin-2': useSkin2,
            })}
            ref={ref}
          >
            <span
              className={classNames('sub-tab', 'main-tab', {
                active: activeSubTab === 'all',
              })}
              onClick={() => {
                setActiveSubTab('all')
                sendTeaCommEvent('click_series_qa_top_tab', {
                  car_series_id: seriesId,
                  tab_name: '最新问答',
                })
              }}
            >
              最新问答
              {/* <img src={useSkin2 ? drop_down_arrow_white : drop_down_arrow}/> */}
            </span>
            {subMenu.map(
              ({ chi_name, tab_name }) =>
                tab_name !== 'all' && (
                  <span
                    key={tab_name}
                    className={classNames('sub-tab', {
                      active: activeSubTab === tab_name,
                    })}
                    onClick={() => {
                      setActiveSubTab(tab_name)
                      sendTeaCommEvent('click_series_qa_top_tab', {
                        car_series_id: seriesId,
                        tab_name: subMenu.find(
                          (item) => item.tab_name === tab_name
                        )?.chi_name,
                      })
                    }}
                  >
                    {chi_name}
                  </span>
                )
            )}
            <Button
              type="new_primary"
              className="publish-button"
              onClick={handleTogglePublisher}
            >
              <>
                <img src={publish_icon} className="publish-icon" />
                <span className="publish-button-text">提问</span>
              </>
            </Button>
          </div>
          <Modal
            visible={showPublisher}
            onClose={handleTogglePublisher}
            className="publisher-modal"
            closable={true}
            CloseIcon={CloseIconForPublisher}
          >
            <Publisher
              onPublish={handlePublish}
              defaultCommunity={{
                series_id: String(seriesId),
                series_name: seriesName,
              }}
              tabs={[{ key: 'qa', value: '问答' }]}
            />
          </Modal>
          <FeedContext.Provider
            value={{
              onDeletePost: handleDelete,
            }}
          >
            {qas.length > 0 ? (
              <>
                <ScrollLoader
                  end={false}
                  loadMoreHandler={loadMoreHandler}
                  loading={loading}
                >
                  <div>
                    {qas.map((item) => {
                      const { ugcType, info, unique_id_str } = item
                      info.group_id = unique_id_str
                      info.ugcType = ugcType
                      if (!item?.info?.user_info) {
                        return null
                      }
                      return (
                        <div
                          key={unique_id_str}
                          className="card"
                          onClick={() => {
                            sendTeaCommEvent('click_series_qa_list_item', {
                              car_series_id: seriesId,
                              group_id: unique_id_str,
                              article_type: '最新问答',
                            })
                          }}
                        >
                          <ArticleCard {...item} />
                        </div>
                      )
                    })}
                  </div>
                </ScrollLoader>
                {loading && <Loading />}
              </>
            ) : (
              <span className="no-article">
                <img src={empty_icon} />
                暂无问答
              </span>
            )}
          </FeedContext.Provider>
        </section>
        <section className="right-part">
          <Leaderboard
            type="qa"
            data={rankData}
            className="margin-bottom-8"
            seriesId={seriesId}
          />
          <Favour className="margin-bottom-8" />
          <CarList series_id={seriesId} className="margin-bottom-8" />
        </section>
      </div>
      <style jsx>
        {`
          .content-wrapper {
            display: flex;
            width: 1196px;
            margin: 8px auto 0;
          }
          .left-part {
            width: 868px;
            min-height: 630px;
            margin-right: 8px;
            position: relative;
          }
          .head {
            height: 40px;
            display: flex;
            align-items: center;
            margin-bottom: 8px;
          }
          .skin-2 {
            width: 1196px;
            height: 60px;
            padding: 18px auto 17px 16px;
            background-color: #1f2129;
            color: #c9cbd6;
            position: sticky;
            top: 0;
            z-index: 101;
          }

          .skin-2 .sub-tab {
            font-size: 18px;
          }
          .skin-2 .active::after {
            width: 100%;
            height: 4px;
            bottom: -19px;
            left: 0;
            transform: translateX(0);
          }

          .head .main-tab {
            margin-left: 16px;
          }
          .main-tab img {
            width: 14px;
            height: 14px;
            object-position: center;
            object-fit: cover;
          }
          .sub-tab {
            margin-left: 40px;
            font-size: 16px;
            line-height: 22px;
            font-weight: 500;
            cursor: pointer;
          }
          .active {
            cursor: default;
            position: relative;
          }
          .active::after {
            position: absolute;
            content: '';
            bottom: -4px;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 3px;
            background-color: #ffcc32;
          }
          :global(.head .publish-button) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 112px;
            height: 40px;
            border-radius: 2px;
            justify-self: flex-end;
            margin-left: auto;
          }
          :global(.skin-2 .publish-button) {
            margin-right: 24px;
          }
          .publish-icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
            object-position: center;
            margin-right: 4px;
          }
          .publish-button-text {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #1f2129;
          }
          :global(.publisher-modal) {
            z-index: 1000 !important;
          }

          // 注意portal会影响css后代选择器 不可通过设置关系选择器来增加权重 因而直接使用了important
          // TODO: 待优化。
          :global(.publisher-modal .modal-body) {
            padding: 0 !important;
            overflow-y: visible !important;
            overflow: visible !important;
          }
          :global(.publisher-modal .modal-container) {
            overflow-y: visible !important;
            overflow: visible !important;
          }
          .card {
            width: 868px;
            background-color: white;
            padding: 24px;
            margin-bottom: 8px;
          }
          .right-part {
            width: 320px;
          }
          :global(.margin-bottom-8) {
            margin-bottom: 8px;
          }
          .no-article {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #606370;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-article > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            object-position: center;
          }
        `}
      </style>
    </React.Fragment>
  )
}
